import difference from "lodash/difference";

export const hasEntryDiff = (
  currentEntryIds: string[],
  previousEntryIds: string[],
): boolean => {
  // 初回投稿時に、1件以上選択されている場合
  if (previousEntryIds.length === 0) {
    return currentEntryIds.length > 0;
  }

  // 前回の応募数と比較して異なる場合
  if (currentEntryIds.length !== previousEntryIds.length) {
    return true;
  }

  // 応募数が同数の場合、差分を比較
  return difference(currentEntryIds, previousEntryIds).length > 0;
};
